import { useEffect, useRef } from "react";
import Glide from "@glidejs/glide";
import { HeroSection } from "../../components/HeroSection/HeroSection";
import { CashAdvanceSection } from "../../components/CashAdvance/CashAdvanceSection";
import { AboutProCashSection } from "../../components/AboutProCash/AboutProCashSection";
import { HowItworksSection } from "../../components/HowItWorks/HowItworksSection";
import { BenefitsChoosingSection } from "../../components/BenefitsChoosing/BenefitsChoosingSection";
import { SuccessStoriesSection } from "../../components/SuccessStories/SuccessStoriesSection";
import { HowToApply } from "../../components/HowToApply/HowToApply";
import { TestimonialSection } from "../../components/Testimonials/TestimonialSection";
import { ReadyPropelSection } from "../../components/ReadyPropel/ReadyPropelSection";
import { FooterSection } from "../../components/Footer/FooterSection";
import { GrowNowComp } from "../../components/GrowNowComp/GrowNowComp";
import { useLocation } from "react-router-dom";

const GrowNowForm = () => {
  const howItWorks = useRef(null);
  const whyus = useRef(null);
  const benefits = useRef(null);
  const faq = useRef(null);
  const readyPropel = useRef(null);
  const aboutProcash = useRef(null);
  const grownowRef = useRef(null);
  const location = useLocation();
  const data = location?.state;

  useEffect(() => {
    if (data?.fromThankYouPage === "fromThankYouPage") {
      const isReloaded = sessionStorage.getItem("reloaded");
      if (!isReloaded) {
        sessionStorage.setItem("reloaded", "true");
        window.history.replaceState({}, document.title);
        window.location.reload();
      }
    }
  }, [data?.fromThankYouPage]);

  useEffect(() => {
    if (sessionStorage.getItem("reloaded")) {
      sessionStorage.removeItem("reloaded");
    }
  }, []);

  useEffect(() => {
    const slider = new Glide(".glide-02", {
      type: "carousel",
      focusAt: "center",
      perView: 1,
      autoplay: 3000,

      animationDuration: 700,
      gap: 24,
      classNames: {
        nav: {
          active: "[&>*]:bg-wuiSlate-700",
        },
      },
      breakpoints: {
        1024: {
          perView: 1,
        },
        640: {
          perView: 1,
        },
      },
    }).mount();

    return () => {
      slider.destroy();
    };
  }, []);

  useEffect(() => {
    const slider = new Glide(".glide-01", {
      type: "carousel",
      focusAt: "center",
      perView: 3,
      autoplay: 3000,
      animationDuration: 700,
      gap: 24,
      breakpoints: {
        1024: {
          perView: 1,
        },
        640: {
          perView: 1,
        },
      },
    }).mount();

    const updateActiveDot = () => {
      const buttons = document.querySelectorAll(
        ".glide-02 [data-glide-el='controls[nav]'] button span"
      );
      buttons.forEach((button, index) => {
        if (index === slider.index) {
          button.classList.add("bg-black");
          button.classList.remove("bg-white/20");
        } else {
          button.classList.add("bg-white/20");
          button.classList.remove("bg-black");
        }
      });
    };

    slider.on(["mount.after", "run"], updateActiveDot);

    return () => {
      slider.destroy();
    };
  }, []);

  useEffect(() => {
    const gtagScript = document.createElement("script");
    gtagScript.async = true;
    gtagScript.src =
      "https://www.googletagmanager.com/gtag/js?id=AW-11530121883";
    //document.head.appendChild(gtagScript);

    const gtagInitScript = document.createElement("script");
    gtagInitScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-11530121883');
      `;
    //document.head.appendChild(gtagInitScript);

    const gtagScript2 = document.createElement("script");
    gtagScript2.async = true;

    gtagScript2.src = "https://www.googletagmanager.com/gtag/js?id=G-470989317";
    //document.head.appendChild(gtagScript2);

    const gtagInitScript2 = document.createElement("script");
    gtagInitScript2.innerHTML = `
         window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-470989317');
        `;
    //document.head.appendChild(gtagInitScript2);

    const gtagScript3 = document.createElement("script");
    gtagScript3.async = true;

    gtagScript3.src =
      "https://www.googletagmanager.com/gtag/js?id=G-00LTPXRR8L";
    //document.head.appendChild(gtagScript3);

    const gtagInitScript3 = document.createElement("script");
    gtagInitScript3.innerHTML = `
         window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-00LTPXRR8L');
        `;
    //document.head.appendChild(gtagInitScript3);

    return () => {
      // if (gtagScript.parentNode) {
      //   document.head.removeChild(gtagScript);
      // }
      // if (gtagInitScript.parentNode) {
      //   document.head.removeChild(gtagInitScript);
      // }
      // gtagScript2.remove();
      // gtagInitScript2.remove();
      // gtagScript3.remove();
      // gtagInitScript3.remove();
    };
  }, []);

  return (
    <div>
      <HeroSection
        benefits={benefits}
        whyus={whyus}
        howItWorks={howItWorks}
        faq={faq}
        grownowRef={grownowRef}
      />
      <GrowNowComp grownowRef={grownowRef} />
      <CashAdvanceSection whyus={whyus} grownowRef={grownowRef} />
      <AboutProCashSection
        aboutProcash={aboutProcash}
        grownowRef={grownowRef}
      />
      <HowItworksSection howItWorks={howItWorks} grownowRef={grownowRef} />
      <BenefitsChoosingSection benefits={benefits} />
      <SuccessStoriesSection />
      <HowToApply faq={faq} />
      <TestimonialSection />
      <ReadyPropelSection readyPropel={readyPropel} grownowRef={grownowRef} />
      <FooterSection
        benefits={benefits}
        whyus={whyus}
        howItWorks={howItWorks}
        faq={faq}
        readyPropel={readyPropel}
        aboutProcash={aboutProcash}
      />
    </div>
  );
};

export default GrowNowForm;
